<template>
    <BaseDialog
        :showDialog="showImageUploadOnlyDialog"
        maxDialogWidth="600"
        maxCardHeight="600"
        headline="lang_LABEL_RELEASES_UPLOAD_COVER_IMAGE"
        :close="closeDialog"
        persistent
        :alvqa="alvContext + '-' + alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid> 
                <v-row class="mb-3">
                    <v-col 
                        v-html="dialogText"
                        
                        :alvqa="alvContext + '-' + alvqa + '-text'"
                    ></v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:actionsWithValidation>
            <v-card-actions class="pt-0 pb-0 pr-6 pl-6">
                <v-container fluid>
                    <v-form>
                        <v-row>
                            <v-col cols="8">
                                <v-file-input
                                    v-model="file"
                                    ref="coverUploader"
                                    :label="$t('lang_GENERAL_CAPTION_SELECT_FILE')"
                                    accept="image/jpeg"
                                    @change="fileExt = $alvPlugin.extractFileExt(file)"
                                    @click:clear="resetVal()"
                                    show-size
                                    :rules="[value => !value || validFile || $t('lang_LABEL_RELEASES_COVER_IMAGE_WARNING_WRONG_FILE_TYPE')]"
                                    :alvqa="alvContext + '-' + alvqa + '-file-input-import-file'"
                                ></v-file-input>
                            </v-col>
                            <v-spacer />
                            <v-col 
                                class="text-right" 
                                align-self="center"
                            >
                            <BaseButton 
                                :disabled="!validFile || !file || disableButton"
                                @click="submitFile"
                                label="lang_GENERAL_BUTTON_SAVE"
                                :alvqa="alvContext + '-' + alvqa+'-button-upload'"
                            />    
                            </v-col>
                        </v-row> 
                    </v-form>
                </v-container>  
            </v-card-actions>
        </template>
    </BaseDialog>
</template>

<script>

import api from '@/api_alv'
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name:'LabelReleasesCoverImageUploadDialog',

    components: {
        BaseDialog,
        BaseButton,
    },

    props: {
        context: {
            type: String,
            default: ''
        },
        alvContext: {
            type: String,
            default: ''
        }
    },
     data() {
        return {
            formData: new FormData(),
            file: null,
            fileExt: '',
            valid: false,
            alvqa: 'label-releases-cover-image-upload-dialog',
            errors:[],
            disableButton: false,
        }
    },

    computed: {  

            showImageUploadOnlyDialog: {
                get() { return this.$store.getters.getShowImageUploadOnlyDialog },
                set(value) { this.$store.commit('setShowImageUploadOnlyDialog', value) }
            },
            validFile(){
                if(this.file !== null){
                    if(this.file.type === "image/jpeg"){
                        this.valid = true
                    }else{
                        this.valid = false
                    }
                }
                return this.valid
            },
            dialogText(){
            let uploadText = this.$t('lang_LABEL_RELEASES_UPLOAD_COVER_IMAGE_DIALOG_TEXT') 
                             + '<br />'
            
            return uploadText +=  this.$t('lang_LABEL_RELEASES_UPLOAD_COVER_IMAGE_JPG_TYPE')
        },
    },

    methods:{
        closeDialog() {
                this.showImageUploadOnlyDialog = false 
                this.file = null 
                this.formData = new FormData()
                this.valid = false
                 this.disableButton = false
        },
        async submitFile(){
            this.disableButton = true
            let alvId = this.$store.getters.getLabelReleasesDetails.alvId
            let dir ='images/' + alvId
            let selectedFileType = this.$refs.coverUploader._data.initialValue.type
            

            if(selectedFileType === "image/jpeg"){
                this.formData.append('file',this.file)
                let response = await api.putFile(dir, this.formData)
                this.$store.commit('setLabelReleasesImageUrl',response.response.path)
                this.$store.commit('setExpandedLabelReleases', [])
                this.closeDialog()

                this.$store.dispatch("fetchLabelReleases")

            }
        },
        async resetVal() {
            await this.$nextTick()
            this.file = null
        },
    }
}
</script>

<style>

</style>